module.exports = __webpack_public_path__ + "img/auburn-univ.be61baa8.jpg";